module.exports = __webpack_public_path__ + "static/media/move_it_icon.f04a3629.svg";